module.exports = __webpack_public_path__ + "static/media/themxb6_-webfont.4e87d1c0.woff";